import tonStyles from './../ton.json'

export default {
  color: tonStyles.colors.PrimaryBlack,
  inverseColor: tonStyles.colors.PrimaryWhite
}
